export const userStatus = JSON.parse(document.getElementById('user-config').textContent);
